import { badgeLabelsComponent } from './badgeLabelsComponent';
import { pdpSpecificVideoLockupComponent } from './pdpSpecificVideoLockupComponent';
import { twPaginationComponent } from './twPaginationComponent';
import { searchComponent } from './searchComponent';

export const tailwind = {
  badgeLabelsComponent,
  pdpSpecificVideoLockupComponent,
  twPaginationComponent,
  searchComponent,
};
